
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M14 22h71v15H14zM14 43h43v15H14zM14 64h76v15H14z"}})])])
          )
        }
      }
    